import React from "react";
import { Switch } from "react-router-dom";
import { $t } from "~/i18n.js";
import { ClubPublicRoute } from "~/router.jsx";
import { VoucherCheckout } from "./checkoutflow/VoucherCheckout.jsx";
import { VoucherThankYou } from "./ThankYou.jsx";

export function VoucherRoutes({ children = [] }) {
  return (
    <Switch>
      <ClubPublicRoute
        path="/voucher/thankyou/:uuid"
        component={VoucherThankYou}
        title={$t("Bedankt")}
      />

      <ClubPublicRoute
        path="/voucher/:slug/:uuid"
        component={VoucherCheckout}
        title={$t("Bon")}
      />

      <ClubPublicRoute
        path="/voucher/:slug"
        component={VoucherCheckout}
        title={$t("Bon")}
      />

      <ClubPublicRoute
        path="/gift/:slug/:uuid"
        component={VoucherCheckout}
        title={$t("Cadeaubon")}
      />

      <ClubPublicRoute
        path="/gift/:slug"
        component={VoucherCheckout}
        title={$t("Cadeaubon")}
      />


      {children}
    </Switch>
  );
}
